export default "__VITE_ASSET__C8aVA3Iy__"